"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CheckBoxComponent.default;
  }
});

var _CheckBoxComponent = _interopRequireDefault(require("./CheckBox-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }